<div *ngIf="field" class="form-group">
  <app-aaos-form-field-title [field]="field" [displayText]="field.displayName"></app-aaos-form-field-title>
  <div *ngIf="field.tooltipText" class="smallerText textFieldTooltipText emailTooltipText">{{field.tooltipText}}</div>
</div>
